module.exports = __webpack_public_path__ + "img/LogoLoading_katsu.ef984f64.png";